<script>
  import Block from './block.svelte'
  import Column from './column.svelte'

  export let top = 30
  export let bottom = undefined
  export let left = 0
  export let right = undefined
  export let showing = false

</script>

<Block position=relative on:mouseleave={()=>showing=false}>
  <Column width=100% align=center>
    <Block
      display=flex
      on:mouseenter={()=>showing=true}
      cursor=pointer
    >
      <slot name='target'></slot>
    </Block>
    <Block 
      hidden={!showing} position=absolute
      {top} {bottom} {left} {right} zIndex=1000
    >
      <slot name='toast'></slot>
    </Block>
  </Column>
</Block>
